/**
 * Takes an expression as input and returns array of its arguments;
 * Example:- `sum(sum(sum(1,3), sum($budget1, 1))` => `["sum(sum(1,3))", " sum($budget1, 1)"]`
 * @param {String} expr
 */
export const breakArguments = expr => {
	let level = 0,
		insideLiteral = false,
		result = [],
		top = -1,
		effectiveExpr = expr.substring(expr.indexOf("("));
	for (let i = 0; i < effectiveExpr.length; i++) {
		if (effectiveExpr[i] === "(" && !insideLiteral) {
			level += 1;
			if (level === 1) {
				top = i + 1;
			}
		} else if (
			effectiveExpr[i] === '"' &&
			!insideLiteral &&
			!(effectiveExpr[i - 1] === "'" && effectiveExpr[i + 1] === "'")
		) {
			insideLiteral = true;
		} else if (
			effectiveExpr[i] === '"' &&
			insideLiteral &&
			(effectiveExpr[i + 1] === ")" || effectiveExpr[i + 1] === ",") &&
			!(effectiveExpr[i - 1] === "'" && effectiveExpr[i + 1] === "'")
		) {
			insideLiteral = false;
		} else if (effectiveExpr[i] === ")" && !insideLiteral) {
			level -= 1;
			if (level === 0 && i === effectiveExpr.length - 1) {
				result.push(effectiveExpr.substring(top, i));
			}
		} else if (effectiveExpr[i] === "," && level === 1 && !insideLiteral) {
			result.push(effectiveExpr.substring(top, i));
			top = i + 1;
		}
	}
	return result.map(arg => {
		arg = arg.replace("'\"'", '"');
		return arg;
	});
};

/**
 * Returns the type of argument `variable`, `expression`, `number` `literal` or `null`
 * @param {String} argument
 */
export const checkArgument = argument => {
	const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?]/;
	if (argument[0] === '"' && argument[argument.length - 1] === '"') {
		return "literal";
	} else if (argument[0] === "[" && argument[argument.length - 1] === "]") {
		return "array";
	} else if (argument[0] === "$") {
		return "variable";
	} else if (argument.indexOf("(") !== -1) {
		return "expression";
	} else if (!isNaN(parseFloat(argument)) && !format.test(argument)) {
		return "number";
	} else if (argument === "null") {
		return "null";
	} else if (argument === "true" || argument === "false") {
		return "boolean";
	} else {
		return "literal";
	}
};

/**
 * Returns the operator of the expression.
 * Example: `sum(sum(sum(1,3), sum($budget1, 1))` => `sum`
 */
export const findOperator = expression => {
	return expression.substring(0, expression.indexOf("("));
};
